module.exports = __webpack_public_path__ + "static/media/qr-code.d527f44d.jpg";